import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  moduleId: module.id,
  selector: 'dashed-collapse-btn',
  templateUrl: 'dashed-collapse-btn.component.html',
  styleUrls: ['dashed-collapse-btn.component.scss'],
})
export class DashedCollapseBtnComponent {
  @Input() showLabel: boolean = true;
  @Input() label: boolean = true;
  @Input() collapsed: boolean = false;

  @Output() clicked: EventEmitter<any> = new EventEmitter();
}
